import { Box, Divider, Flex, Text, VStack } from '@chakra-ui/react'
import { css, keyframes } from '@emotion/react'
import { Trans } from '@lingui/react/macro'
import type { FC } from 'react'

import CopilotLogo from './assets/AgentCopilotLogo.svg'
import BigFlower from './assets/BigFlower.svg'
import Flower from './assets/Flower.svg'
import Guirlande from './assets/Guirlande.svg'

const pulse = keyframes`
  0% {
    transform: scale(1);
    }
  50% {
    transform: scale(0.95);
  }     
  100% {
    transform: scale(1);
  }
`

export const AwaitingScreen: FC = () => {
  return (
    <Box
      height="100vh"
      bg="white"
      width="100%"
      background="linear-gradient(0deg, rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), radial-gradient(88.67% 177.33% at 103.33% 100%, #33C4B3 0%, rgba(51, 196, 179, 0) 100%), linear-gradient(360deg, rgba(51, 196, 179, 0.25) 0%, rgba(51, 196, 179, 0.5) 66%)"
    >
      <Box position="absolute" top={0} left={0}>
        <Guirlande />
      </Box>
      <Flex
        alignItems="center"
        justify="center"
        width="100%"
        flexDirection="column"
      >
        <VStack mt="25vh" alignItems="center">
          <Box
            animation={`${pulse} 4s ease infinite`}
            maxHeight={300}
            height="20vw"
          >
            <CopilotLogo
              height="100%"
              width="auto"
              filter="drop-shadow(4.596px 0 9.192px rgba(219, 172, 245, 0.10)) drop-shadow(9.192px 9.192px 13.788px rgba(219, 172, 245, 0.09)) drop-shadow(22.98px 18.384px 18.384px rgba(219, 172, 245, 0.05)) drop-shadow(41.364px 32.172px 22.98px rgba(219, 172, 245, 0.01)) drop-shadow(68.939px 45.96px 22.98px rgba(219, 172, 245, 0.00))"
            />
          </Box>
          <Divider borderColor="greys.200" mt="2vh" w="80%" />
          <Flex
            flexDirection="column"
            alignItems="center"
            mt={6}
            gap={2}
            zIndex={2}
          >
            <Text
              fontWeight="600"
              fontSize="20px"
              color="#0c1436"
              textAlign="center"
            >
              <Trans>Waiting for a conversation</Trans>
            </Text>
            <Text
              fontSize="14px"
              color="#8f93a3"
              textAlign="center"
              maxWidth="423px"
            >
              <Trans>
                Just a moment, and you’ll be ready to dial in to create great
                customer experiences.
              </Trans>
            </Text>
          </Flex>
        </VStack>
      </Flex>

      <Box
        position="absolute"
        bottom={0}
        width="100%"
        height="300px"
        bg="white"
        css={css`
          --c: 100px;
          aspect-ratio: 3/2;
          mask: radial-gradient(
            60% var(--c) at top,
            #0000 calc(100% - 1px),
            #000
          );
        `}
      />
      <Box position="absolute" bottom={0} left={0}>
        <BigFlower />
      </Box>
      <Box position="absolute" bottom={0} right={0}>
        <Flower />
      </Box>
    </Box>
  )
}
